import { Pipe, PipeTransform } from '@angular/core';
import { TemplateField } from '../../models/template.model';
import { ReportFieldFormatterService } from '../../report-field-formatter.service';
import { ReportRecord } from '../../models/report.model';

@Pipe({
  name: 'reportLabelFormatter',
  standalone: false,
})
export class ReportLabelFormatterPipe implements PipeTransform {
  constructor(private reportFieldFormatterService: ReportFieldFormatterService) {}

  transform(
    record: ReportRecord | ReportRecord[],
    settings: {
      templateId: number;
      field: TemplateField;
    }
  ): string {
    return this.reportFieldFormatterService.getLabelDesc(record, settings);
  }
}
